namespace Matrix.Data {
    export class EventLogColumns {
        static columnsKey = 'Data.EventLog';
    }
}
